import styled from '@emotion/styled'
import { Toggle, ToggleProps } from 'rsuite'
import theme from '../../../styles/theme'
import React from 'react'

export const StandardToggleButton = styled(Toggle)`
  margin: 0.5rem;

  &.rs-toggle {
    --rs-toggle-checked-bg: ${theme.colors.suplementGreen} !important;
    --rs-toggle-checked-hover-bg: #1b5e20 !important;
    --rs-toggle-bg: #d3d3d3 !important;
    --rs-toggle-hover-bg: #a9a9a9 !important;
  }
`

// Create a wrapper component with default props
export const StandardToggleWithDefaults: React.FC<ToggleProps> = (props) => (
  <StandardToggleButton size="md" checkedChildren="✓" {...props} />
)
